import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import s from 'base/bolt/boltApp.sss';
import ShowtimesMessage from 'components/bolt/showtimes/showtimesMessage.js';
import { accessNested } from 'utils/utils';
import Store from 'store/store';

export default class BoltApp extends BaseComp.default {
	render() {
		const baseJSX = super.render(this.props, this.state);
		let activePage = Store.get().activePage;
		if (activePage !== 'boltShowtimes') return baseJSX;
		const dimensions = accessNested(Store.get(), 'client.dimensions');
		const message = accessNested(Store.get(), 'appData.copy.baseCopy.$RESIZE_MESSAGE') || 'Please resize your browser window or press get tickets below to open a new window.';
		if (dimensions?.width < 765 && dimensions?.height < 450) return (
			<div 
				class={s.messageWrapper} 
			>
				<ShowtimesMessage message={message} />
			</div>
		);
		return baseJSX;
	}
}